import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { folderAccessSettingsKeys } from 'app/pages/library/videos/videoList/components/folderAccessSettingsKeys';
import { foldersKeys } from '../folders/foldersKeys';
import { FolderAccessSettings } from 'app/pages/library/videos/videoList/components/types';
import { useTranslation } from 'react-i18next';

interface IUpdateVideoArchiveStatus {
  sendNotification: boolean;
  message: string;
  accessSettings: FolderAccessSettings[];
  folderId: number;
}

export const addFolderAccessSettings = async (
  data: IUpdateVideoArchiveStatus
): Promise<{ success: boolean }> => {
  const response = await EXPRESS_API.post(
    `/folders/${data.folderId}/access-settings`,
    data
  );
  return response.data;
};

export const useAddFolderAccessSettings = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation(
    (data: {
      sendNotification: boolean;
      message: string;
      accessSettings: FolderAccessSettings[];
      folderId: number;
    }) => addFolderAccessSettings(data),
    {
      onError: () => {
        errorToast({
          title: t('Failed to share folder. Please try again later.'),
        });
      },
      onSuccess: async (_data, variables) => {
        successToast({
          title: t('Folder Shared successfully'),
        });
        await queryClient.invalidateQueries([
          folderAccessSettingsKeys.list(variables.folderId),
        ]);
        await queryClient.invalidateQueries(foldersKeys.all());
        await queryClient.invalidateQueries(foldersKeys.grouped(true));
      },
    }
  );
};
